<!-- Presales Sidebar -->
<p-drawer [closeOnEscape]="false" [visible]="showSidebar()" (onHide)="closeNotificationSidebar()" [showCloseIcon]="true" position="right" [blockScroll]="true" [dismissible]="false" styleClass="w-full payment-sidebar no-header p-0">
  <!-- Header -->
  <ng-template #headless>
    <div class="border-bottom-1 border-300 relative flex align-items-center justify-content-between sticky left-0 top-0 w-full surface-0 z-5 p-2">
      <div class="flex align-items-center">
        <div (click)="closeNotificationSidebar()" class="h-2rem w-2rem cursor-pointer surface-200 flex align-items-center justify-content-center"><i class="fa fa-times text-xl text-600"></i></div>
        <label  class="font-bold cursor-pointer text-sm mx-2">{{'STAFF_NOTIFICATIONS.DIRECT_NOTI' | translate}}</label>
        <p-toggleSwitch (onChange)="showDirectNotifications(directNotifications)" />
      </div>

      <p-button [label]="'STAFF_NOTIFICATIONS.BTN_MARK_ALL_READ' | translate" (onClick)="markAllAsRead()" styleClass="p-button-text text-xs" />
    </div>
    <!-- Header -->

    <!-- Content -->
    @if (currentTenantNotifications.value.length > 0 || otherTenantNotifications.value.length > 0) {
      <p-scrollPanel styleClass="w-full h-screen">
        <ul class="list-none p-0 m-0">
          @for (data of currentTenantNotifications.getValue(); track data) {
            <li class="flex py-3 pl-3 pr-5 border-bottom-1 border-300 relative" [ngClass]="!data.is_read ? 'bg-blue-50' : ''">
              <div class="flex align-items-center relative cursor-pointer" (click)="openClientSidebar(data)">
                @if (!data.is_read) {
                  <i class="fa fa-circle text-primary text-xxs"></i>
                }
                <p-avatar [image]="data.client.image"  [label]="!data.client?.image ? (data.client?.full_name | titlecase | shortName) : ''" styleClass="ml-2 md:h-3rem md:w-3rem" shape="circle" />
                <div [ngClass]="getClass(data)" class="text-white flex align-items-center justify-content-center p-1 border-round absolute right-0 top-0 -mr-3 mt-2">
                  <i [ngClass]="getIcon(data)"></i>
                </div>
              </div>
              <div class="text-sm ml-4 cursor-pointer" (click)="openClientSidebar(data)">
                <div><span class="font-bold">{{ data.client && data.client.full_name ? data.client.full_name : '' }}</span> {{ 'STAFF_NOTIFICATIONS.'+getReplyText(data) | translate }} <span class="font-bold">"{{ getInteractionContent(data.payload.content) }}"</span></div>
                <div class="flex align-items-center text-600 mt-2">
                  <span class="text-xxs"> {{ data.created_date | DayAgo }} </span>
                  <span class="mx-2 text-3xl line-height-1 -mt-3 border-circle">.</span>
                  @if (isDirectNotification(data)) {
                    <span class="surface-300 p-1 border-round text-xs">{{'STAFF_NOTIFICATIONS.DIRECT' | translate}}</span>
                  }
                </div>
              </div>
              <i class="fa fa-times text-xl cursor-pointer absolute right-0 top-0 mt-4 mr-4 text-600" (click)="markAsDelete(data)"></i>
            </li>
          }
        </ul>
        <div class="p-3">
          <!-- Notification Box -->
          @for (data of otherTenantNotifications.getValue(); track trackByFn($index, data)) {
            <div class="surface-200 cursor-pointer p-3 border-round text-sm mb-2">
              <div class="flex align-items-center justify-content-between" (click)="toggleInfo(data)">
                <div class="flex align-items-center">
                  <p-badge [value]="data.notifications.length" severity="danger" />
                  <div class="mx-2">{{'STAFF_NOTIFICATIONS.NEW_NOTI_FOR' | translate}} <strong class="font-bold">{{ getTenantName(data.tenantId) }}</strong></div>
                </div>
                <div class="text-xxs text-600 white-space-nowrap">{{ data.notifications[0].created_date | DayAgo }}</div>
              </div>
              @if (data.showInfo) {
                <div class="-mt-1 -mb-3">
                  <p-message severity="info" icon="fa fa-info-circle" aria-label="change-branch-to-message">
                    <div class="flex align-items-center w-full -my-2 md:m-0">
                      <i class="fa fa-info-circle text-xl"></i>
                      <div class="ml-3 text-sm">{{'STAFF_NOTIFICATIONS.CHANGE_BRANCH_TO' | translate}} <strong class="font-bold">{{ getTenantName(data.tenantId) }}</strong> {{'STAFF_NOTIFICATIONS.BTANCH_TO_VIEW' | translate}}</div>
                    </div>
                  </p-message>
                </div>
              }
            </div>
          }
          <!-- Notification Box -->
          <!-- Notification Box -->
          @if (remainingCount() > 0) {
            <div class="surface-200 cursor-pointer p-3 border-round text-sm mb-2">
              <div class="flex align-items-center justify-content-between" (click)="loadMoreNotifications()">
                <strong class="w-full text-primary text-center block" [innerText]="'STAFF_NOTIFICATIONS.LOAD_MORE' | translate : {count : remainingCount()}" ></strong>
              </div>
            </div>
          }
          <!-- Notification Box -->
        </div>
      </p-scrollPanel>
    } @else {
      <div class="text-center py-6" >
        <p class="text-sm mb-4">{{ 'STAFF_NOTIFICATIONS.NO_NOTIFICATION' | translate }}</p>
        <img src="/assets/img/img-no-notifications.svg" [alt]="'STAFF_NOTIFICATIONS.NO_NOTIFICATION' | translate" >
      </div>
    }
    <!-- Content -->

    <!-- Content -->

    <!-- Content -->
  </ng-template>

</p-drawer>
<!-- Presales Sidebar -->

@if (showClientSidebar) {
  <fitness-force-client-info-sidebar [showClientSidebar]="showClientSidebar" [activeClientId]="activeClientId" [interactionId]="interactionId" (closeSidebar)="CloseSidebar($event)" />
}
